import React from 'react';
import EmailInboxSettings from '../EmailInboxSettings';
import InboxBlocklistSettings from '../InboxBlocklistSettings';
import ForwardingAddresses from '../ForwardingAddresses';

// E-postinkorg section. Forwarding addresses + manual blocklist are universal;
// the Gmail/Outlook auto-polling connector (EmailInboxSettings) is gated on the
// `email_inbox_scanning` feature, surfaced here via the `showScanning` prop.
const EmailInboxSection = ({ companyId, showScanning }) => (
  <>
    <div id="vidarebefordran">
      <ForwardingAddresses companyId={companyId} />
    </div>
    {showScanning && (
      <div id="koppla-inkorg">
        <EmailInboxSettings companyId={companyId} />
      </div>
    )}
    <div id="blocklista">
      <InboxBlocklistSettings companyId={companyId} />
    </div>
  </>
);

export default EmailInboxSection;
